<template>
  <v-app>
    <v-app-bar color="#1B5E20" :extension-height="appBarExtensionHeight"
      :image="require('@/assets/legumes_2000_largeur.jpg')" scroll-behavior="fade-image" class="d-print-none">
      <template v-slot:image>
        <v-img gradient="to bottom right, rgba(27, 94, 32, .9), rgba(0, 0, 0, 0.2)"></v-img>
      </template>
      <div class="d-flex align-center ml-4">
        <router-link to="/">
          <v-img alt="Logo Baie Des Saveurs" class="shrink mr-2" cover
            :src="require('@/assets/feuille-seulement-bds.png')" transition="scale-transition" width="40" />
        </router-link>
      </div>
      <div class="pt-2 ml-1 logo-font" :class="{
        'logo-font-small': $vuetify.display.xs
      }">
        <router-link to="/" style="text-decoration: none; color: inherit;" class="text-white">
          Baie des saveurs
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <v-btn variant="text" tile to="/comment-ca-marche" v-if="$vuetify.display.mdAndUp" color="primary"
        class="mr-4 menu-button">
        <span class="text-white">
          {{ $t('app:howTo') }}
        </span>
      </v-btn>
      <v-btn variant="text" tile to="/produits" v-if="$vuetify.display.mdAndUp" color="primary"
        class="mr-4 menu-button">
        <span class="text-white">
          {{ $t('app:shop') }}
        </span>
      </v-btn>
      <v-btn variant="text" tile to="/producteurs" v-if="$vuetify.display.mdAndUp" color="primary"
        class="mr-4 menu-button">
        <span class="text-white">
          {{ $t('app:producers') }}
        </span>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="text-center" v-if="$store.state.user === null && $vuetify.display.mdAndUp">
        <v-menu open-on-hover location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn variant="text" to="/connexion" v-bind="props" color="white">
              <v-icon start>login</v-icon>
              <span>
                {{ $t('app:login') }}
              </span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/inscription">
              <template v-slot:prepend>
                <v-icon>how_to_reg</v-icon>
              </template>
              <v-list-item-title>
                {{ $t('app:register') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-btn v-if="$store.state.user === null && $store.state.locale === 'en' && $vuetify.display.mdAndUp"
        variant="text" @click="switchLanguage('fr')" color="white">
        FR
      </v-btn>
      <v-btn v-if="$store.state.user === null && $store.state.locale === 'fr' && $vuetify.display.mdAndUp"
        variant="text" @click="switchLanguage('en')" color="white">
        EN
      </v-btn>
      <router-link :to="openInvoiceUrl" v-if="this.$store.state.user !== null">
        <v-badge floating class="basket-badge-content" color="white" :class="{
          'mr-4': $vuetify.display.mdAndUp,
          'mr-2': $vuetify.display.smAndDown
        }" :content="nbItemsInBasket" :model-value="nbItemsInBasket > 0">
          <v-icon color="white">shopping_cart</v-icon>
        </v-badge>
      </router-link>
      <v-menu v-if="$store.state.user === null && $vuetify.display.smAndDown">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon color="white">
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/comment-ca-marche">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:howTo') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/produits">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:shop') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/producteurs">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:producers') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/connexion">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:login') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/inscription">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:register') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu location="bottom" v-if="$store.state.user !== null">
        <template v-slot:activator="{ props }">
          <v-btn icon size="x-large" v-bind="props" color="white">
            <v-icon color="white">menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/comment-ca-marche" v-if="$vuetify.display.smAndDown">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:howTo') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/produits" v-if="$vuetify.display.smAndDown">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:shop') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/producteurs" v-if="$vuetify.display.smAndDown">
            <v-list-item-title>
              <v-btn variant="text">{{ $t('app:producers') }}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="$vuetify.display.smAndDown"></v-divider>
          <v-list-item :to="'/membre/' + $store.state.user.id" v-if="$store.state.user !== null">
            <template v-slot:prepend>
              <v-avatar color="primary" dark size="35">
                <span class="text-white">
                  {{ initials }}
                </span>
              </v-avatar>
            </template>
            <v-list-item-title>
              {{ $t('app:informations') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="switchLanguage()">
            <template v-slot:prepend>
              <v-icon class="material-icons-outlined">language</v-icon>
            </template>
            <v-list-item-title>
              <span v-if="$store.state.locale === 'en'">Français</span>
              <span v-else>English</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item :to="'/membre/' + $store.state.user.id + '/factures'" v-if="$store.state.user !== null">
            <template v-slot:prepend>
              <v-icon class="material-icons-outlined">assignment</v-icon>
            </template>
            <v-list-item-title>
              {{ $t('app:historique') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <template v-slot:prepend>
              <v-icon>exit_to_app</v-icon>
            </template>
            <v-list-item-title>
              {{ $t('app:logout') }}
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="isAdmin"></v-divider>
          <v-list-subheader v-if="isAdmin">
            Administration
          </v-list-subheader>
          <v-list-item :to="'/admin/rapports'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon class="material-icons-outlined">preview</v-icon>
            </template>
            {{ $t('app:reports') }}
          </v-list-item>
          <v-list-item :to="'/admin/produits'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon>local_florist</v-icon>
            </template>
            {{ $t('app:products') }}
          </v-list-item>
          <v-list-item :to="'/admin/factures'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon class="material-icons-outlined">assignment</v-icon>
            </template>
            {{ $t('app:invoices') }}
          </v-list-item>
          <v-list-item :to="'/admin/membres'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon>people</v-icon>
            </template>
            {{ $t('app:members') }}

          </v-list-item>
          <v-list-item :to="'/admin/distributions'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon class="material-icons-outlined">local_shipping</v-icon>
            </template>

            {{ $t('app:Distributions') }}

          </v-list-item>
          <v-list-item :to="'/admin/producteurs'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon>
                agriculture
              </v-icon>
            </template>

            Producteurs

          </v-list-item>
          <v-list-item :to="'/admin/categories'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon>category</v-icon>
            </template>
            Catégories

          </v-list-item>
          <v-list-item :to="'/admin/configurations'" v-if="isAdmin">
            <template v-slot:prepend>
              <v-icon>settings</v-icon>
            </template>

            {{ $t('app:configs') }}

          </v-list-item>
        </v-list>
      </v-menu>
      <template v-slot:extension v-if="shouldShowDistributionNavBar">
        <div style="width:100%;" class="vh-center">
          <v-progress-circular v-if="isLoading" indeterminate :size="60" :width="2" color="white"></v-progress-circular>
          <Distribution-Nav-Bar v-else :openOrBeforeDeliveryInvoice="openOrBeforeDeliveryInvoice"
            :openDistribution="openDistribution" :beforeDeliveryDistribution="beforeDeliveryDistribution"
            :incomingDistribution="incomingDistribution" :isOpenInvoiceConfirmed="isOpenInvoiceConfirmed"
            :openInvoice="openInvoice" :openOrBeforeDeliveryDistribution="openOrBeforeDeliveryDistribution"
            :hasWrongPickupLocation="hasWrongPickupLocation" :openInvoiceUrl="openInvoiceUrl"
            ref="distributionNavBar"></Distribution-Nav-Bar>
        </div>
      </template>
    </v-app-bar>
    <router-view />
    <v-footer class="font-weight-medium d-print-none" variant="flat" color="blackish">
      <v-col class="vh-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>
          Baie des saveurs
        </strong>
      </v-col>
    </v-footer>
    <v-overlay :model-value="isLoadingFlow">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <MemberEditDialog ref="memberEditDialog"></MemberEditDialog>
  </v-app>
</template>

<script>
import LoadingFlow from "@/LoadingFlow";
import I18n from "@/i18n";
import MemberService from "@/service/MemberService";
import DistributionNavBar from "@/components/DistributionNavBar.vue";
import MemberEditDialog from "@/components/MemberEditDialog.vue";
import DistributionService from "@/service/DistributionService";
import OpenInvoiceService from "@/service/OpenInvoiceService";
import Pages from "@/Pages";
import Distribution from "@/Distribution";
import PickupLocationService from "@/service/PickupLocationService.js";

export default {
  name: "App",
  components: { DistributionNavBar, MemberEditDialog },
  data: function () {
    I18n.i18next.addResources("fr", "app", {
      login: "Se connecter",
      products: "Produits",
      shop: "Marché",
      producers: "Producteurs",
      howTo: "Comment ca marche",
      register: "S'inscrire",
      informations: "Informations",
      logout: "Déconnecter",
      historique: "Historique",
      invoices: "Factures",
      reports: "Rapports",
      configs: "Configurations",
      members: "Membres"
    });
    I18n.i18next.addResources("en", "app", {
      login: "Login",
      products: "Products",
      shop: "Market",
      producers: "Producers",
      howTo: "How it works",
      register: "Register",
      informations: "Informations",
      logout: "Logout",
      historique: "History",
      invoices: "Invoices",
      reports: "Reports",
      configs: "Configurations",
      members: "Membres"
    });
    return {
      isLoadingFlow: false,
      loadingFlows: LoadingFlow.loadingFlows,
      isScrollTop: null,
      isLoading: false,
      openDistribution: null,
      beforeDeliveryDistribution: null,
      incomingDistribution: null,
      openOrBeforeDeliveryInvoice: null,
      openOrBeforeDeliveryDistribution: null,
      appBarExtensionHeight: "140",
      hasShownWrongPickupLocationDialog: false,
    }
  },
  mounted: async function () {
    this.isLoading = true;
    if (this.$store.state.user) {
      await this.refreshMember();
    } else {
      await this.refreshContext();
    }
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  methods: {
    refreshMember: async function () {
      const member = await MemberService.getById(this.$store.state.user.id)
      if (member === false) {
        console.log("erreur de connexion avec le serveur")
        return;
      }
      await this.$store.dispatch('setUser', member);
    },
    refreshContext: async function () {
      console.log("refreshing context")
      this.openDistribution = await DistributionService.getOpen();
      if (this.openDistribution === null) {
        this.beforeDeliveryDistribution = await DistributionService.getBeforeDelivery();
        if (this.beforeDeliveryDistribution !== null) {
          this.openOrBeforeDeliveryDistribution = this.beforeDeliveryDistribution;
          if (this.$store.state.user !== null) {
            this.openOrBeforeDeliveryInvoice = await DistributionService.getInvoiceOfMemberInDistribution(
              this.$store.state.user.id,
              this.beforeDeliveryDistribution.id
            )
          }
        }
        this.incomingDistribution = await DistributionService.getIncoming();
      } else {
        this.openOrBeforeDeliveryDistribution = this.openDistribution;
      }

      let openInvoice = null
      if (this.$store.state.user !== null && this.openDistribution !== null) {
        openInvoice = this.openOrBeforeDeliveryInvoice = await OpenInvoiceService.getOpenInvoice(this.$store.state.user.id)
      }
      await this.$store.dispatch('setOpenInvoice', openInvoice);
      await this.$store.dispatch('setDistributions', {
        open: this.openDistribution,
        beforeDelivery: this.beforeDeliveryDistribution,
        openOrBeforeDelivery: this.openOrBeforeDeliveryDistribution,
        incoming: this.incomingDistribution
      });
      const pickupLocations = await PickupLocationService.list();
      await this.$store.dispatch('setPickupLocations', pickupLocations);
      this.isLoading = false;
      await this.$nextTick();
      const distributionNavBar = this.$refs.distributionNavBar;
      let distributionStatusText = "";
      if (distributionNavBar !== null && distributionNavBar !== undefined && distributionNavBar.$el) {
        distributionStatusText = distributionNavBar.$el.innerText;
      }
      await this.$store.dispatch('setDistributionStatusText', distributionStatusText);
      if (this.$store.state.user) {
        await this.$refs.memberEditDialog.showIfInvalid(
          this.$store.state.user
        );
      }
    },
    switchLanguage: function (locale) {
      if (locale === undefined) {
        locale = this.$store.state.locale === 'en' ? 'fr' : 'en'
      }
      if (this.$store.state.user !== null) {
        MemberService.updateLocale(
          this.$store.state.user.id,
          locale
        );
      }
      this.$store.dispatch('setLocale', locale)
    },
    logout: function () {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$router.push('/connexion');
    },
    onScroll() {
      this.isScrollTop = document.documentElement.scrollTop > 30 ? false : true
    }
  },
  computed: {
    shouldShowDistributionNavBar: function () {
      return this.isScrollTop && Pages.loggedOutOnlyPages.indexOf(this.$route.name) === -1;
    },
    initials: function () {
      if (this.$store.state.user === null) {
        return "";
      }
      const fullname = this.$store.state.user.firstname + " " + this.$store.state.user.lastname;
      return fullname.split(" ").map((n) => n[0]).join("");
    },
    isAdmin: function () {
      return this.$store.state.user !== null && this.$store.state.user.isAdmin;
    },
    user: function () {
      return this.$store.state.user
    },
    openInvoice: function () {
      return this.$store.state.openInvoice
    },
    pickupLocations: function () {
      return this.$store.state.pickupLocations;
    },
    isOpenInvoiceConfirmed: function () {
      return this.$store.state.openInvoice !== null && this.$store.state.openInvoice.status === 'confirmed';
    },
    openInvoiceUrl: function () {
      if (this.$store.state.user === null) {
        return "/connexion"
      }
      return "/membre/" + this.$store.state.user.id + "/bondecommande/edit";
    },
    hasWrongPickupLocation: function () {
      if (this.$store.state.user === null) {
        return false
      }
      if (this.openOrBeforeDeliveryDistribution === null) {
        return false;
      }
      if (this.openOrBeforeDeliveryInvoice === null) {
        return false;
      }
      return !Distribution.isMemberPickupLocationOk(
        this.openOrBeforeDeliveryDistribution,
        this.$store.state.user,
        this.openOrBeforeDeliveryInvoice,
        this.pickupLocations
      )
    },
    nbItemsInBasket: function () {
      if (this.openInvoice === null || this.openDistribution === null || this.isOpenInvoiceConfirmed || this.hasWrongPickupLocation) {
        return 0;
      }
      const nbDifferentItems = this.openInvoice.InvoicesItems.length;
      if (nbDifferentItems === 1) {
        return this.openInvoice.InvoicesItems.reduce((sum, item) => {
          return sum + item.productQty
        }, 0)
      }
      return nbDifferentItems
    },
  },
  watch: {
    loadingFlows: function () {
      this.isLoadingFlow = this.loadingFlows.length > 0;
    },
    shouldShowDistributionNavBar: function () {
      this.$store.dispatch('setIsAppBarExtended', this.shouldShowDistributionNavBar)
    },
    user: function () {
      this.refreshContext()
    },
    openInvoice: function () {
      if (this.openInvoice !== null) {
        this.openOrBeforeDeliveryInvoice = this.openInvoice
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>


<style lang="scss">
$primary: #1B5E20;

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.blue-title {
  color: #17347c !important;
}

.green-text {
  color: $primary !important;
}

.vh-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-center {
  display: flex;
  align-items: center;
}

.v-bottom {
  display: flex;
  align-items: end;
}

.v-toolbar__content {
  .v-btn--active {
    .v-btn__overlay {
      opacity: 0;
    }

    border-bottom: 2px solid whitesmoke;
    font-weight: bold;
  }
}

.material-symbols-outlined {
  font-variation-settings: 'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
}

@import url('https://fonts.googleapis.com/css2?family=Slabo+27px&display=swap');

.logo-font {
  font-family: 'Slabo 27px', serif;
  text-decoration: none !important;
  font-size: 35px;
  align-self: inherit !important;
  float: right;
}

.logo-font-small {
  font-size: 25px;
}

.secondRow {
  width: 100%;
  background-color: #2c3e50;
  color: whitesmoke;
}

.distributionMenu {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.green-border {
  border: 1px solid $primary;
}

.bigger-hint {

  .v-text-field__details,
  .v-messages {
    min-height: 20px;
  }

  .v-messages__message {
    font-size: 16px;
    line-height: inherit;
  }
}

.gray-background {
  background-color: #eeeeee
}

.basket-badge-content {
  .v-badge__badge {
    color: $primary !important;
    font-weight: bold;
  }
}

.v-application a {
  color: #1b5e20;
}

.blackish {
  color: #272727 !important;
}

@media print {
  .print-page-break {
    break-before: page;
    page-break-before: always;
  }
}
</style>
